import styled, { css } from 'styled-components';

export default styled.div`
  margin: 0 auto;

  padding-left: ${(props) => props.theme.grid.containerGap};
  padding-right: ${(props) => props.theme.grid.containerGap};

  @media all and (min-width: ${(props) => props.theme.breakingpoints.sm}) {
    max-width: ${(props) => props.theme.breakingpoints.sm};
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    max-width: ${(props) => props.theme.breakingpoints.md};
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    max-width: ${(props) => props.theme.breakingpoints.lg};
    ${(props) => props.extraSmall && css`
      max-width: ${props.theme.breakingpoints.md};
    `}
  }

  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    max-width: ${(props) => props.theme.breakingpoints.xl};
    ${(props) => props.small && css`
      max-width: ${props.theme.breakingpoints.lg};
    `}
    ${(props) => props.extraSmall && css`
      max-width: ${props.theme.breakingpoints.md};
    `}
  }
`;
